{
  "REGISTER": {
    "TRY_WOOT": "Vytvoriť účet",
    "TITLE": "Registrovať",
    "TESTIMONIAL_HEADER": "Stačí jeden krok k posunu vpred",
    "TESTIMONIAL_CONTENT": "Ste jeden krok od zapojenia svojich zákazníkov, ich udržania a hľadania nových.",
    "TERMS_ACCEPT": "Vytvorením účtu súhlasíte s našimi <a href=\"https://chat.jarabot.com/terms\">obchodnými podmienkami</a> a <a href=\"https://chat.jarabot.com/privacy-policy\">zásadami ochrany osobných údajov</a>",
    "OAUTH": {
      "GOOGLE_SIGNUP": "Registrovať sa cez Google"
    },
    "COMPANY_NAME": {
      "LABEL": "Názov spoločnosti",
      "PLACEHOLDER": "Zadajte názov svojej spoločnosti. Napr. Wayne Enterprises",
      "ERROR": "Názov spoločnosti je príliš krátky."
    },
    "FULL_NAME": {
      "LABEL": "Celé meno",
      "PLACEHOLDER": "Zadajte svoje celé meno. Napr. Bruce Wayne",
      "ERROR": "Celé meno je príliš krátke."
    },
    "EMAIL": {
      "LABEL": "Pracovný e-mail",
      "PLACEHOLDER": "Zadajte svoju pracovnú e-mailovú adresu. Napr. bruce{'@'}wayne{'.'}enterprises",
      "ERROR": "Zadajte prosím platnú pracovnú e-mailovú adresu."
    },
    "PASSWORD": {
      "LABEL": "Heslo",
      "PLACEHOLDER": "Heslo",
      "ERROR": "Heslo je príliš krátke.",
      "IS_INVALID_PASSWORD": "Heslo by malo obsahovať aspoň 1 veľké písmeno, 1 malé písmeno, 1 číslicu a 1 špeciálny znak."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Potvrdiť heslo",
      "PLACEHOLDER": "Potvrdiť heslo",
      "ERROR": "Heslá sa nezhodujú."
    },
    "API": {
      "SUCCESS_MESSAGE": "Registrácia bola úspešná",
      "ERROR_MESSAGE": "Nepodarilo sa pripojiť k chatovaciemu serveru. Skúste to prosím znova."
    },
    "SUBMIT": "Vytvoriť účet",
    "HAVE_AN_ACCOUNT": "Už máte účet?",
    "TERMS_LINKS": "<a href=\"https://chat.jarabot.com/terms\">Podmienky používania</a> - <a href=\"https://chat.jarabot.com/privacy-policy\">Zásady ochrany osobných údajov</a>"
  }
}
